import { Image, Row, Typography, Space, Col, Skeleton } from 'antd';
import styled from 'styled-components';
import { Button, Divider } from 'antd-mobile';
import Drawer from '../drawer';
import useTranslations from '../../hooks/useTranslations';
import useFetchQuery from '../../hooks/useFetchQuery';
import DynamicIcon from '../dynamic-icon';

const { Text } = Typography;

const BarcodeWrapper = styled(Space)`
    width: 100%;
    .ant-space-item {
        display: flex;
        justify-content: center;
    }
`;

const SpaceStyled = styled(Space)`
    .ant-space-item {
        display: flex;
        justify-content: center;
    }
`;

const ButtonSocmed = styled(Button)`
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding-bottom: unset;
    padding-top: 4px !important;
    padding-left: 4px;
    padding-right: 4px;
`;

function DrawerBarcode({ visible, onClose, title, children, maskClosable = true }) {
    const { t } = useTranslations();

    const textEasyMassageCS = t('EasyMassageCS', 'Easy Massage CS');

    const handleClick = (url) => {
        window.open(url, '_blank');
    };

    const _onClose = () => {
        onClose();
    };

    const { data, isLoading } = useFetchQuery({
        enabled: () => Boolean(visible),
        url: '/contacts',
        method: 'get',
        onFetchSuccess: ({ data }) => {
            return {
                listContact: data?.contacts,
                primaryContact: data?.contacts?.find((item) => item?.platform === 'line'),
            };
        },
    });

    const mappingPlatform = {
        telegram: <DynamicIcon iconName="telegram" />,
        whatsapp: <DynamicIcon iconName="whatsapp" />,
        wechat: <DynamicIcon iconName="wechat" />,
        email: <DynamicIcon iconName="email" />,
    };

    return (
        <Drawer height={550} visible={visible} onClose={_onClose} maskClosable={maskClosable} title={title}>
            <Row justify="center" style={{ flexDirection: 'column', rowGap: 16 }}>
                {isLoading ? (
                    <Skeleton active={isLoading} />
                ) : (
                    <>
                        <div
                            style={{
                                background: '#F5F5f5',
                                padding: 8,
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <BarcodeWrapper direction="vertical">
                                <Image src={data?.primaryContact?.qr_code} preview={false} height={160} width={160} />
                                <Text strong>{textEasyMassageCS}</Text>
                                <Text
                                    onClick={() => handleClick(data?.primaryContact?.url)}
                                    style={{ color: 'var(--primary-color)', cursor: 'pointer' }}
                                >
                                    {data?.primaryContact?.url}
                                </Text>
                            </BarcodeWrapper>
                        </div>
                        <Row gutter={[8, 8]} wrap={false} align="middle">
                            {data?.listContact
                                ?.filter((item) => item?.platform !== 'line')
                                .map((item, index) => {
                                    return (
                                        <Col
                                            key={index}
                                            style={{
                                                flex: 1,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <SpaceStyled direction="vertical" size={0}>
                                                <ButtonSocmed key={index} onClick={() => handleClick(item?.url)}>
                                                    {mappingPlatform[item?.platform]}
                                                </ButtonSocmed>
                                                <Text>{item?.display_name}</Text>
                                            </SpaceStyled>
                                        </Col>
                                    );
                                })}
                        </Row>{' '}
                    </>
                )}
                <Divider style={{ padding: 0, margin: 0 }} />
                {children}
            </Row>
        </Drawer>
    );
}

export default DrawerBarcode;
